import Layout from '../../components/Layout/Main';
import Content from '../../components/Pages/Notifications';
import { displayName } from '../../config';

const Notifications = (): JSX.Element => {
  document.title = `${displayName}: Notifications`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
};

export default Notifications;
